import { IHeaderData } from '../AppTable'

export const headerDataFirstValue = (
  tableName: string,
  headerData: IHeaderData[],
) => {
  const headerDataLS = localStorage.getItem(tableName)
  return headerDataLS
    ? JSON.parse(headerDataLS).length === headerData.length
      ? JSON.parse(headerDataLS)
      : headerData
    : headerData
}
